var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.36621V8.14121",
    stroke: "#61616F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0171 1.66699C6.9504 1.66699 4.46707 4.15033 4.46707 7.21699V8.96699C4.46707 9.53366 4.23374 10.3837 3.94207 10.867L2.88374 12.6337C2.23374 13.7253 2.68374 14.942 3.88374 15.342C7.86707 16.667 12.1754 16.667 16.1587 15.342C17.2837 14.967 17.7671 13.6503 17.1587 12.6337L16.1004 10.867C15.8087 10.3837 15.5754 9.52532 15.5754 8.96699V7.21699C15.5671 4.16699 13.0671 1.66699 10.0171 1.66699Z",
    stroke: "#61616F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7746 15.6836C12.7746 17.2086 11.5246 18.4586 9.99961 18.4586C9.24128 18.4586 8.54128 18.1419 8.04128 17.6419C7.54128 17.1419 7.22461 16.4419 7.22461 15.6836",
    stroke: "#61616F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.04621ade93573fa70af0898a52b12369.svg";
export { ForwardRef as ReactComponent };